<template>
  <div class="user-wrapper" :class="theme">
    <a-tooltip placement="bottomLeft" v-if="!isMobile()">
      <span class="action" @click="showClick">
        <a-icon type="search"></a-icon>
      </span>
      <template slot="title">
        <span>{{ this.$t('disp.menu.searchMenu') }}</span>
      </template>
    </a-tooltip>

    <component
      :is="searchMenuComp"
      v-show="searchMenuVisible || isMobile()"
      class="borders"
      :visible="searchMenuVisible"
      :footer="null"
      @cancel="searchMenuVisible = false"
    >
      <a-select
        class="search-input"
        showSearch
        :showArrow="false"
        placeholder
        optionFilterProp="children"
        :filterOption="filterOption"
        :open="isMobile() ? true : null"
        :style="isMobile() ? { width: '100%', marginBottom: '50px' } : {}"
        @change="searchMethods"
        @blur="hiddenClick"
      >
        <a-select-option v-for="(site, index) in searchMenuOptions" :key="index" :value="site.id">
          {{ $getTextByLocale(site.meta.title) }}
        </a-select-option>
      </a-select>
    </component>

    <a-tooltip placement="bottomLeft">
      <span class="action" @click="handleClickHelp">
        <a class="logout_title question-circle" href="javascript:;">
          <a-icon type="question-circle-o"></a-icon>
        </a>
      </span>
      <template slot="title">
        <span>{{ this.$t('disp.menu.help') }}</span>
      </template>
    </a-tooltip>

    <header-notice v-if="false" class="action" />

    <a-dropdown>
      <span class="action action-full ant-dropdown-link user-dropdown-menu">
        <!-- <a-avatar class="avatar" size="small" :src="getAvatar()" /> -->
        <a-avatar class="avatar" size="small" icon="user" />
        <span v-if="isDesktop()">{{ nickname() }}</span>
      </span>
      <a-menu slot="overlay" class="user-dropdown-menu-wrapper">
        <a-menu-item key="0">
          <router-link to="../../views/exception/404.vue">
            <a-icon type="user" />
            <span>{{ this.$t('disp.menu.profile') }}</span>
          </router-link>
        </a-menu-item>

        <!--<a-menu-item key="1">
          <router-link to="../../views/exception/404.vue">
            <a-icon type="form" />
            <span>{{ this.$t('disp.menu.acountSetting') }}</span>
          </router-link>
        </a-menu-item>-->

        <a-menu-item key="4" @click="updatePassword">
          <a-icon type="safety" />
          <span>{{ this.$t('disp.menu.changePassword') }}</span>
        </a-menu-item>

        <a-menu-item key="3" @click="$refs.SelectRelation.handleOpen()">
          <span
            class="mdi mdi-file-tree-outline"
            style="color: var(--color-primary-90p); margin-right: 11px; font-size: 16px"
          ></span>
          <span>所属信息</span>
        </a-menu-item>

        <a-menu-item key="2" @click="systemSetting">
          <a-icon type="setting" />
          <span>网站偏好设置</span>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
    <span class="action" @click="handleLogout">
      <a class="logout_title" href="javascript:;">
        <a-icon type="logout" style="margin-right: 2px" />
        <span v-if="isDesktop()">&nbsp;退出</span>
      </a>
    </span>

    <UserPassword ref="UserPassword"></UserPassword>

    <SelectRelation ref="SelectRelation"></SelectRelation>

    <SettingDrawer ref="SettingDrawer" :closable="true" :title="this.$t('disp.menu.systemSetting')"></SettingDrawer>

  </div>
</template>

<script>
import UserPassword from './UserPassword'
import SettingDrawer from '@/components/setting/SettingDrawer'
import SelectRelation from '@/views/k00/k0002/modules/SelectRelation'
import { mapActions, mapGetters, mapState } from 'vuex'
import { mixinDevice } from '@/utils/mixin.js'

export default {
  name: 'UserMenu',
  mixins: [mixinDevice],
  data() {
    return {
      // update-begin author:sunjianlei date:20200219 for: 头部菜单搜索规范命名 --------------
      searchMenuOptions: [],
      searchMenuComp: 'span',
      searchMenuVisible: false,
      loginUser: this.$getLoginUser(),
      att_flag: false,
      // update-begin author:sunjianlei date:20200219 for: 头部菜单搜索规范命名 --------------
    }
  },
  components: {
    UserPassword,
    SelectRelation,
    SettingDrawer,
  },
  props: {
    theme: {
      type: String,
      required: false,
      default: 'light',
    },
  },
  /* update_begin author:zhaoxin date:20191129 for: 做头部菜单栏导航*/
  created() {
    let lists = []
    this.searchMenus(lists, this.permissionMenuList)
    this.searchMenuOptions = [...lists]
  },
  computed: {
    ...mapState({
      // 后台菜单
      permissionMenuList: (state) => state.user.permissionList,
    }),
  },
  /* update_end author:zhaoxin date:20191129 for: 做头部菜单栏导航*/
  watch: {
    // update-begin author:sunjianlei date:20200219 for: 菜单搜索改为动态组件，在手机端呈现出弹出框
    device: {
      immediate: true,
      handler() {
        this.searchMenuVisible = false
        this.searchMenuComp = this.isMobile() ? 'a-modal' : 'span'
      },
    },
    // update-end author:sunjianlei date:20200219 for: 菜单搜索改为动态组件，在手机端呈现出弹出框
  },
  methods: {
    /* update_begin author:zhaoxin date:20191129 for: 做头部菜单栏导航*/
    showClick() {
      if (this.searchMenuVisible) {
        this.searchMenuVisible = false
      } else {
        this.searchMenuVisible = true
      }
    },
    hiddenClick() {
      this.shows = false
    },
    /* update_end author:zhaoxin date:20191129 for: 做头部菜单栏导航*/
    ...mapActions(['Logout']),
    ...mapGetters(['nickname', 'avatar', 'userInfo']),
    getAvatar() {
      if (this.avatar()) {
        return window._CONFIG['staticDomainURL'] + '/' + this.avatar()
      } else {
        return null
      }
    },
    handleLogout() {
      const that = this

      // window.location.href = '/'
      //var el = document.querySelector('.GlobalLayout')
      //el.classList.remove('animate__backInLeft')
      //el.classList.add('animate__fadeOutLeft')

      //setTimeout(() => {
      //  that.$router.push({ path: '/user' })
      //}, 600)

      this.$confirm({
        title: this.$t('disp.warn'),
        content: this.$t('msg.logout'),
        onOk() {
          return that.Logout({}).then(() => {
            that.$router.push({ path: '/user' })
          })
        },
        onCancel() {},
      })
    },
    handleClickHelp() {
      window.open(window._CONFIG['staticDomainURL'] + '/E:/opt/blaze/help/操作手册.pdf')
    },
    updatePassword() {
      let username = this.userInfo().username
      this.$refs.UserPassword.show(username)
    },
    systemSetting() {
      this.$refs.SettingDrawer.showDrawer()
    },
    /* update_begin author:zhaoxin date:20191129 for: 做头部菜单栏导航*/
    searchMenus(arr, menus) {
      for (let i of menus) {
        if (!i.hidden && 'layouts/RouteView' !== i.component) {
          arr.push(i)
        }
        if (i.children && i.children.length > 0) {
          this.searchMenus(arr, i.children)
        }
      }
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // update_begin author:sunjianlei date:20191230 for: 解决外部链接打开失败的问题
    searchMethods(value) {
      let route = this.searchMenuOptions.filter((item) => item.id === value)[0]
      if (route.meta.internalOrExternal === true || route.component.includes('layouts/IframePageView')) {
        window.open(route.meta.url, '_blank')
      } else {
        this.$router.push({ path: route.path })
      }
      this.searchMenuVisible = false
    },
    // update_end author:sunjianlei date:20191230 for: 解决外部链接打开失败的问题
    /*update_end author:zhaoxin date:20191129 for: 做头部菜单栏导航*/
  },
}
</script>

<style lang="less" scoped>
.user-wrapper .search-input {
  width: 180px;
  color: inherit;

  /deep/ .ant-select-selection {
    background-color: inherit;
    border: 0;
    border-bottom: 1px solid #d9d9d9;
    border-radius: 0;
    height: 32px;
    box-shadow: none;

    &__placeholder,
    &__field__placeholder {
      color: inherit;
    }
  }
}

.ant-avatar-image {
  margin: 17px 10px 20px 0 !important;
}

span.action {
  padding-top: 0px !important;
  margin-top: 0px;
  height: 100% !important;

  & > * {
    position: relative;
    top: -1px;
  }
}
</style>

<style scoped>
.logout_title {
  color: inherit;
  text-decoration: none;
}
</style>
